/* eslint-disable import/prefer-default-export -- Intentionally using named export */
import { useTranslation } from "../../../../features/localization/hooks";
export const useRecommendedPlanName = (paywallRoles) => {
    const { t } = useTranslation();
    return (paywallRoles ?? []).map((role) => {
        switch (role) {
            case "sm_basic":
                return t("subscription:tier.sm_basic");
            case "sm_premium":
                return t("subscription:tier.sm_premium");
            case "paid_basic":
                return t("subscription:tier.paid_basic");
            case "paid_premium":
                return t("subscription:tier.paid_premium");
            case "paid_minimal":
                return t("subscription:tier.paid_minimal");
            default:
                // eslint-disable-next-line custom/no-dynamic-i18n-key -- creating feature string dynamically based on role
                return t(`subscription:tier.${role}`);
        }
    });
};
